<div>
  <p>{{ 'COMMON.VISANA_INSURED.QUESTION' | translate }}</p>
  <p *ngIf="!!validatorService.getErrorMessage(formControl, validateForm)" class="error body-6 bold">
    <dap-lib-icon iconColor="red" iconSize="16" name="error"></dap-lib-icon>
    {{ validatorService.getErrorMessage(formControl, validateForm) }}
  </p>
</div>
<dap-lib-toggle
  data-cy="existing-customer-toggle"
  [labelSelected]="'COMMON.VISANA_INSURED.YES' | translate"
  [labelUnselected]="'COMMON.VISANA_INSURED.NO' | translate"
  [formControl]="formControl"
  [hasError]="!!validatorService.getErrorMessage(formControl, validateForm)"
></dap-lib-toggle>
